<template>
  <div class="sign">
    <div id="signUp" class="container box mainBox">
      <p class="tac">電話番号で新規登録すると<br>貰えるビットコインが5倍！</p>
      <router-link to="sign" class="skeleton btn tel">電話番号で新規登録</router-link>
      <a href="#" @click="signInTwitter" class="skeleton btn twitter">Twitterで新規登録</a>
      <p>
        または
      </p>
      <router-link to="sign" class="btn tel">電話番号でログイン</router-link>
      <a href="#" @click="signInTwitter" class="btn twitter">Twitterでログイン</a>
    </div>
    <Ad1/>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import Ad1 from './ad/Ad1'

export default {
  name: 'home',
  components: {
    Ad1
  },
  data () {
    return {}
  },
  methods: {
    signInTwitter: function () {
      let provider = new firebase.auth.TwitterAuthProvider()
      firebase.auth().signInWithPopup(provider).then(result => {
        this.$router.push('/main')
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box{
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}
.btn{
  display: block;
  width: 100%;
  max-width: 420px;
  height: 60px;
  background: #aaa;
  color: #fff;
  text-align: center;
  text-decoration: none;
  line-height: 60px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
  font-size: 20px;
  font-weight: bold;
}
.btn.tel{
  background: #73C700;
}
.btn.twitter{
  background: #38A1F3;
}
.btn.skeleton{
  background: none;
  border: 2px solid #aaa;
  color: #aaa;
}
.btn.skeleton.twitter{
  border-color: #38A1F3;
  color: #38A1F3;
}
.btn.skeleton.tel{
  border-color: #73C700;
  color: #73C700;
}
.sign p{
  text-align: center;
  color: #999;
  font-size: 18px;
}
@media all and (max-width: 480px) {
  .btn{
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
    font-size: 16px;
  }
}
.tac{
  text-align: center;
  color: #222 !important;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue